import { render, staticRenderFns } from "./ResignCommunity.vue?vue&type=template&id=03bb8ff6&scoped=true&"
import script from "./ResignCommunity.vue?vue&type=script&lang=js&"
export * from "./ResignCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb8ff6",
  null
  
)

export default component.exports